import _Number$isNaN from 'babel-runtime/core-js/number/is-nan';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import generateId from '@com/utils/generate-id.js';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css';
import { getImageSize } from '@com/image';
import frameImgList from './frame-img-list.vue';
import frameBtn from './frame-btn.vue';
// function numbersCloseEnoughToEqual(n1, n2) {
//   return Math.abs(n1 - n2) < Number.EPSILON
// }

export default {
  components: { frameImgList: frameImgList, frameBtn: frameBtn },

  props: {
    upload: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    /**
     * @type {{autoCropWidth: number, autoCropHeight: number, type: string, img: string}}
     * autoCropWidth 图片宽度，autoCropHeight 图片高度，type 图片类型，img 图片资源 dataURL 或 url
     * autoCropWidth/autoCropHeight 这两个属性命名比较奇葩，原因是因为初版使用的组件的命名就是这样的。但是原来的裁切组件能力不足且很难使用，所以更换了新的裁切组件，由于已有多个地方调用该组件，所以命名保持跟原来的一致。
     */
    cropper: {
      type: Object,
      required: true
    },
    filename: {
      type: String
    },
    minRatio: {
      type: Number,
      default: 0.01
    },
    maxRatio: {
      type: Number,
      default: 5
    },
    controllerVisible: {
      type: Boolean,
      default: true
    },
    uploadRequest: {
      type: Function,
      required: false
    },
    dialogAttrs: {
      type: Object,
      default: function _default() {}
    },
    hasValidate: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function,
      default: function _default() {}
    },
    // 自适应，保证图片全部内容都在裁切框内
    adaptive: {
      type: Boolean,
      default: true
    },
    quality: {
      type: Number,
      default: 70
    },
    // 序列帧裁剪后图片名称
    nameList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * @type {title: string, close: string, submit: string}
     * title dialog的title
     * close 关闭按钮的文案
     * submit 提交按钮的文案
     */
    dialogContent: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    var _this = this;

    return {
      uploading: false,
      cropperInstance: null,
      sliderAttrs: {
        min: this.minRatio,
        max: this.maxRatio,
        step: 0.1,
        formatTooltip: function formatTooltip(value) {
          return parseInt(_this.cookCurrentRatio(value) * 100, 10) + '%';
        }
      },
      cropperOffset: {
        top: 0
      },
      cropMoved: false,
      currentRatio: 1,
      currentRatioPercent: '100%',
      initRatio: 0,
      isSameSize: false, // 宽高是否一样
      framesUrl: '' // 切换帧图片url
    };
  },


  computed: {
    dialog: function dialog() {
      var _this2 = this;

      return _extends({
        visible: this.visible,
        title: this.dialogContent && this.dialogContent.title || this.$t('cropperDialog.title'),
        appendToBody: true,
        width: '430px',
        customClass: '' + (this.cropper.fileList && this.cropper.fileList.length ? 'cropper-dialog batch-cropper-dialog' : 'cropper-dialog'),
        beforeClose: function beforeClose(done) {
          if (_this2.beforeClose()) {
            done();
            _this2.close();
          }
        }
      }, this.dialogAttrs);
    },
    submitButton: function submitButton() {
      return {
        type: 'primary',
        loading: this.uploading
      };
    },
    cancelButton: function cancelButton() {
      return {
        disabled: this.uploading
      };
    }
  },

  watch: {
    'dialog.visible': function dialogVisible(val) {
      var _this3 = this;

      if (val === true) {
        setTimeout(function () {
          _this3.cropperInstance = new Cropper(_this3.$refs['cropper-image'], {
            aspectRatio: _this3.cropper.autoCropWidth / _this3.cropper.autoCropHeight,
            cropBoxMovable: false,
            cropBoxResizable: false,
            dragMode: 'move',
            rotatable: false,
            toggleDragModeOnDblclick: false,
            responsive: false,
            guides: false,
            center: false,
            autoCropArea: 0.7,
            ready: function ready() {
              var initZoom = function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _ref2, width, height, ratio;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return getImageSize(_this3.cropper.img);

                        case 2:
                          _ref2 = _context.sent;
                          width = _ref2.width;
                          height = _ref2.height;

                          // 如果原始图片与上传的图片尺寸相同，将其铺满裁切框
                          if (width === _this3.cropper.autoCropWidth && height === _this3.cropper.autoCropHeight) {
                            _this3.isSameSize = true;
                            _this3.initRatio = _this3.getInitRatio();
                            _this3.cropperInstance && _this3.cropperInstance.zoomTo(_this3.initRatio);
                          } else {
                            _this3.isSameSize = false;
                            if (_this3.cropperInstance) {
                              ratio = Math.min(_this3.cropperInstance.getCropBoxData().width / _this3.cropperInstance.getImageData().naturalWidth, _this3.cropperInstance.getCropBoxData().height / _this3.cropperInstance.getImageData().naturalHeight);

                              _this3.cropperInstance && _this3.cropperInstance.zoomTo(_this3.adaptive ? ratio : 1);
                            }
                          }

                        case 6:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this3);
                }));

                return function initZoom() {
                  return _ref.apply(this, arguments);
                };
              }();
              initZoom();
            },
            zoom: function zoom(event) {
              // 将放大缩小限制在1% - 500%
              // Zoom in
              if (event.detail.ratio > event.detail.oldRatio && event.detail.oldRatio >= _this3.maxRatio) {
                event.preventDefault(); // Prevent zoom in
                return;
              }

              // Zoom out
              if (event.detail.ratio < event.detail.oldRatio && event.detail.oldRatio <= _this3.minRatio) {
                event.preventDefault(); // Prevent zoom out
                return;
              }

              _this3.currentRatio = event.detail.ratio;
              console.log(_this3.currentRatio);
            },
            cropmove: function cropmove() {
              _this3.cropMoved = true;
            },
            crop: function crop(event) {
              var cropData = _this3.cropperInstance.getCropBoxData();
              _this3.cropperOffset.top = cropData.top + 12;
            }
          });
        }, 100);
      } else {
        this.cropperInstance && this.cropperInstance.destroy();
      }
    },
    currentRatio: function currentRatio(val) {
      this.currentRatioPercent = parseInt(val * 100, 10) + '%';
    },
    'cropper.value': function cropperValue(val) {
      if (this.cropperInstance) {
        var item = this.cropper.fileList && this.cropper.fileList.find(function (n) {
          return n.id === val;
        });
        if (item) {
          this.cropperInstance.replace(item.url, true);
          this.framesUrl = item.url;
        }
      }
    }
  },

  methods: {
    open: function open() {
      this.$emit('update:visible', true);
    },
    close: function close() {
      this.$emit('update:visible', false);
    },
    handleClose: function handleClose() {
      this.close();
      this.$emit('back');
    },
    zoom: function zoom(num) {
      num = num || 0.1;
      this.cropperInstance && this.cropperInstance.zoom(num);
    },
    beforeClose: function beforeClose() {
      if (this.uploading) {
        this.$message.warning('上传素材中不允许关闭弹窗');
        return false;
      }
      return true;
    },
    cookCurrentRatio: function cookCurrentRatio(ratio) {
      if (ratio) {
        var zoom = Number(ratio.toPrecision(2));
        if (ratio >= this.maxRatio) return this.maxRatio;
        if (ratio <= this.minRatio) return this.minRatio;
        return zoom;
      }
      return ratio;
    },
    getInitRatio: function getInitRatio() {
      // 容器的 70%
      var widthRatio = 370 * 0.7 / this.cropper.autoCropWidth;
      var heightRatio = 370 * 0.7 / this.cropper.autoCropHeight;
      var minRatio = Math.min(heightRatio, widthRatio);
      return minRatio;
    },


    // 单文件上传
    uploadFile: function uploadFile(data) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, file;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.updateUploading(true);
                _context2.prev = 1;
                _context2.next = 4;
                return _this4.uploadRequest({
                  file_base64: data.split(',')[1],
                  filename: _this4.filename || 'temp_' + generateId() + '.' + (_this4.cropper.outputType === 'jpeg' ? 'jpg' : _this4.cropper.outputType),
                  rename: _this4.filename,
                  quality: _this4.quality
                });

              case 4:
                res = _context2.sent;


                if (res.data && res.data.code === 0) {
                  file = res.data.data;

                  _this4.$emit('upload-success', {
                    file: file,
                    width: _this4.cropper.autoCropWidth,
                    height: _this4.cropper.autoCropHeight
                  });
                  _this4.close();
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);

              case 11:
                _this4.updateUploading(false);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 8]]);
      }))();
    },


    // 帧图片上传（序列帧）
    uploadFileList: function uploadFileList(data) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.updateUploading(true);
                _context3.prev = 1;
                _context3.next = 4;
                return _this5.uploadRequest({
                  file_data: _JSON$stringify(data),
                  filename: _this5.filename,
                  unzip: 1,
                  wrap: 1
                });

              case 4:
                res = _context3.sent;


                if (res.data && res.data.code === 0) {
                  _this5.$emit('upload-list-success', res.data.data);
                  _this5.close();
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](1);

                console.log(_context3.t0);

              case 11:
                _this5.updateUploading(false);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 8]]);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var valid;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this6.hasValidate) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 3;
                return _this6.validate();

              case 3:
                valid = _context4.sent;

                if (valid) _this6.getCropData();
                _context4.next = 8;
                break;

              case 7:
                _this6.getCropData();

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    getCropData: function getCropData() {
      var dataURL = '';
      var arr = [];
      if (this.cropper.fileList && this.cropper.fileList.length) {
        arr = this.replaceImgCropper();
      } else {
        dataURL = this.getDateUrl();
      }

      if (this.upload && this.uploadRequest && !this.cropper.fileList) {
        this.uploadFile(dataURL);
      } else if (this.upload && this.uploadRequest && this.cropper.fileList) {
        this.uploadFileList(arr);
      } else {
        this.$emit('crop', dataURL);
        this.$emit('batch-success', arr);
      }
    },
    replaceImgCropper: function replaceImgCropper() {
      var arr = [];
      for (var i = 0; i < this.cropper.fileList.length; i++) {
        this.cropperInstance.replace(this.cropper.fileList[i].url, true);
        var dataURL = this.getDateUrl();
        arr.push({
          data: dataURL.replace('data:image/' + (this.cropper.outputType.toLowerCase() !== 'png' ? 'jpeg' : 'png') + ';base64,', ''),
          name: this.nameList[i]
        });
      }
      // 预览区域切回原图，防止出现页面抖动的情况
      this.cropperInstance.replace(this.framesUrl ? this.framesUrl : this.cropper.img, true);
      return arr;
    },
    getDateUrl: function getDateUrl() {
      var canvas = this.cropperInstance.getCroppedCanvas({
        width: this.cropper.autoCropWidth,
        height: this.cropper.autoCropHeight,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });
      return canvas.toDataURL('image/' + (this.cropper.outputType.toLowerCase() !== 'png' ? 'jpeg' : 'png'), this.quality / 100);
    },
    updateUploading: function updateUploading(val) {
      this.uploading = val;
    },
    zoomTo: function zoomTo(value) {
      this.cropperInstance && this.cropperInstance.zoomTo(value);
    },
    handleChange: function handleChange(val) {
      val = parseInt(val, 10);
      if (_Number$isNaN(val)) {
        val = 100;
      } else {
        if (val < 1) val = 100;
        if (val > 500) val = 500;
      }
      this.currentRatioPercent = val;
      this.currentRatio = this.currentRatioPercent / 100;
    },
    handleBlur: function handleBlur() {
      this.currentRatioPercent = parseInt(this.currentRatioPercent, 10) + '%';
    },
    handleFocus: function handleFocus() {
      this.currentRatioPercent = parseInt(this.currentRatioPercent, 10);
    }
  }
};